import { render, staticRenderFns } from "./EditClientTabs.vue?vue&type=template&id=36c09576"
import script from "./EditClientTabs.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditClientTabs.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./EditClientTabs.vue?vue&type=style&index=0&id=36c09576&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports